import { motion } from "motion/react";

export function HeroSection() {
    return (
        <header className="relative h-screen flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 z-0">
                <video
                    src="https://static.datasquirel.com/images/user-images/user-2/videos/scented-candle-short-video.mp4"
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-full h-full object-cover brightness-75"
                />
            </div>

            <div className="relative z-10 text-center text-white px-6">
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="uppercase tracking-[0.3em] text-sm mb-6 font-light"
                >
                    Artisanal Scented Candles
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.7 }}
                    className="font-serif text-6xl md:text-8xl font-light mb-8 italic"
                >
                    Light Your Soul
                </motion.h2>
                <a href="/collection">
                    <motion.button
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 1 }}
                        className="border border-white/40 px-10 py-4 hover:bg-white hover:text-black transition-all duration-500 uppercase tracking-widest text-xs"
                    >
                        Explore Collection
                    </motion.button>
                </a>
            </div>
        </header>
    );
}
